"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupConfirmation = void 0;
const Field_type_1 = require("../../../types/Field.type");
const GroupOnboardingConfirmation_1 = require("../../enm/GroupOnboardingConfirmation");
exports.GroupConfirmation = {
    priority: 1,
    label: 'fields.enm.group_onboarding_confirmation.label',
    fallbackLabel: 'If you are providing these answers on behalf of multiple companies within the same group (group onboarding), please confirm that the responses in this section apply uniformly to all those companies. If there are any differences for example due to regional laws or regulations, please describe them:',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: GroupOnboardingConfirmation_1.GroupOnboardingConfirmationRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
